import React, { useState, useEffect } from 'react';
import InputField from '../../../CustomInputs/InputField';
import { useFinancialInstitutions } from '../../../../hooks/Payment/useFinancialInstitutions';
import { Controller } from 'react-hook-form';

const Step3 = ({ onPrev, onSubmit, paymentData, formProps }) => {
  const { institutions, error } = useFinancialInstitutions();
  const [tab, setTab] = useState(0);
  const [rawCardNumber, setRawCardNumber] = useState('');
  const { control, setValue } = formProps;
  const { recurrence } = paymentData;

  useEffect(() => {
    if (tab === 0) {
      setValue('paymentMethod', 'CARD');
    } else if (tab === 1) {
      setValue('paymentMethod', 'PSE');
    }
  }, [tab, setValue]);

  return (
    <div className='data-container'>
      <div className='tab-section'>
        <div className='tabs'>
          <div className='tab-control'>
            <nav>
              {recurrence === 'Solo una vez' && (
                <>
                  <button
                    type='button'
                    onClick={() => setTab(0)}
                    className={`${tab === 0 ? 'active' : ''}`}>
                    Card
                  </button>
                  <button
                    type='button'
                    onClick={() => setTab(1)}
                    className={`${tab === 1 ? 'active' : ''}`}>
                    PSE
                  </button>
                </>
              )}
            </nav>
          </div>
        </div>
      </div>
      {tab === 0 && (
        <>
          <h2>Datos de Tarjeta</h2>
          <InputField
            name='cardNumber'
            control={control}
            placeholder='Número de Tarjeta'
            maxLength='19'
            rules={{
              required: 'El número de tarjeta es requerido',
              pattern: {
                value:
                  /^(?:4\d{3}-?\d{4}-?\d{4}-?\d{4}|5[1-5]\d{2}-?\d{4}-?\d{4}-?\d{4}|3[47]\d{2}-?\d{6}-?\d{5}|6(?:011|5\d{2})-?\d{4}-?\d{4}-?\d{4})$/,
                message: 'El número de tarjeta es incorrecto',
              },
            }}
            customOnChange={(e, field) => {
              let value = e.target.value.replace(/\D/g, '');
              setRawCardNumber(value);
              if (value.startsWith('34') || value.startsWith('37')) {
                value = value
                  .replace(/(\d{4})(\d{6})(\d{0,5})/, '$1-$2-$3')
                  .trimEnd('-');
                field.onChange(value);
                field.maxLength = 17;
              } else {
                value = value.match(/.{1,4}/g)?.join('-') || value;
                field.onChange(value);
                field.maxLength = 19;
              }
            }}
            customOnBlur={(e, field) => {
              field.onChange(rawCardNumber);
            }}
          />
          <InputField
            name='expiryDate'
            control={control}
            placeholder='MM/AA'
            maxLength='5'
            rules={{
              required: 'La fecha de expiración es requerida',
              pattern: {
                value: /^(0[1-9]|1[0-2])\/?([0-9]{2})$/,
                message: 'La fecha debe tener el formato MM/AA',
              },
            }}
            customOnChange={(e, field) => {
              let value = e.target.value.replace(/\D/g, '');
              if (value.length === 1 && value > '1') {
                value = '0' + value;
              }
              // Verifica si el primer número es 1 y el segundo mayor a 2, añade un 0
              if (value.length === 2 && value[0] === '1' && value[1] > '2') {
                value = '0' + value[0]; // Transforma 15 a 05, por ejemplo
              }

              // Si tiene 2 caracteres, añade el '/' para dividir mes y año
              if (value.length >= 2) {
                value = value.slice(0, 2) + '/' + value.slice(2);
              }

              // Si borran el año, quita el '/'
              if (value.length === 3) {
                value = value.replace('/', '');
              }
              if (value.length === 5) {
                const year = value.slice(-2); // Obtener los últimos dos caracteres (el año)
                if (parseInt(year, 10) < 24) {
                  // Si el año es menor a 24, reemplázalo por 24 o bloquea el cambio
                  value = value.slice(0, 3) + '24'; // Aquí forzamos el año a ser 24
                }
              }

              field.onChange(value); // Actualiza el campo con el valor formateado
            }}
          />
          <InputField
            name='cvc'
            control={control}
            placeholder='CVC'
            maxLength='4'
            rules={{
              required: 'El CVC es requerido',
              pattern: {
                value: /^[0-9]{3,4}$/,
                message: 'El CVC debe tener 3 o 4 dígitos',
              },
            }}
          />
        </>
      )}
      {tab === 1 && (
        <>
          <h2>Datos de facturación</h2>
          {error ? (
            <h3>error obteniendo entidades financieras: {error}</h3>
          ) : institutions ? (
            <Controller
              name='financialInstitution'
              control={control}
              rules={{ required: 'La entidad financiera es requerida' }}
              defaultValue=''
              render={({ field, fieldState: { error } }) => (
                <div className='form-group'>
                  <label htmlFor='financialInstitution'>
                    Institución financiera
                  </label>
                  <select
                    {...field}
                    name='financialInstitution'
                    className={error ? 'input-error' : ''}>
                    {institutions.map((institution) => (
                      <option
                        key={institution.bankCode}
                        value={institution.bankCode}>
                        {institution.bankName}
                      </option>
                    ))}
                  </select>
                  {error && <p className='error-msg'>{error.message}</p>}
                </div>
              )}
            />
          ) : (
            <p>Cargando instituciones financieras...</p> // Agrega el loader aquí
          )}
        </>
      )}

      <div className='controls'>
        <button
          type='button'
          onClick={onPrev}
          className='btn primary'>
          Anterior
        </button>
        <button
          type='submit'
          className='btn primary'>
          Pagar
        </button>
      </div>
    </div>
  );
};

export default Step3;
